/**
 * Generatos random string based on Math.random
 */
const getRandomString = () => Math.random().toString(36).substring(2)

export default getRandomString
